const AbstractDojoRequestRecord = require('./AbstractDojoRequestRecord');
const DojoConfig = require('../../DojoConfig');

/**
 * After a report request has been sent begin polling to get the generated report.
 */
class DojoTerminalReportPollRequestRecord extends AbstractDojoRequestRecord {
    /**
     * @param {DojoConfig} config
     * @param {String} requestId
     */
    constructor(config, requestId) {
        if (!(config instanceof DojoConfig)) {
            throw new Error('Required instance of DojoConfig is missing');
        }
        if (!requestId) {
            throw new Error('requestId is required');
        }
        const url = 'pac/terminals/' + config.terminalId + '/reports/' + requestId;
        super(
            'GET',
            url
        );
    }
}

module.exports = DojoTerminalReportPollRequestRecord;
